export const BrokerImportToggleGroup = {
  mounted() {
    this.expandedGroups = new Set()
    this.collapsedGroups = new Set()

    this.handleClick = (e) => {
      const btn = e.target.closest("[data-action='toggle-broker-import-group']")
      if (!btn) return

      const { groupId, collapsed } = btn.dataset
      const isCollapsed = collapsed === "true"

      if (isCollapsed) {
        this.expandedGroups.add(groupId)
        this.collapsedGroups.delete(groupId)
      } else {
        this.collapsedGroups.add(groupId)
        this.expandedGroups.delete(groupId)
      }

      const rows = this.el.querySelectorAll(
        `tr[data-group-id="${groupId}"][data-is-account="false"]`,
      )
      rows.forEach((row) => row.classList.toggle("hidden", !isCollapsed))
      btn.dataset.collapsed = isCollapsed ? "false" : "true"
      btn.textContent = isCollapsed ? "▼" : "▶"
    }

    this.el.addEventListener("click", this.handleClick)

    this.observer = new MutationObserver((mutations) => {
      for (const { type, target: row } of mutations) {
        if (type !== "attributes" || row.tagName !== "TR") continue
        const { groupId, isAccount } = row.dataset
        if (!groupId || isAccount !== "false") continue

        if (
          this.expandedGroups.has(groupId) &&
          row.classList.contains("hidden")
        ) {
          row.classList.remove("hidden")
        } else if (
          this.collapsedGroups.has(groupId) &&
          !row.classList.contains("hidden")
        ) {
          row.classList.add("hidden")
        }
      }
    })

    this.observer.observe(this.el, {
      subtree: true,
      attributes: true,
      attributeFilter: ["class"],
    })
  },

  destroyed() {
    this.observer.disconnect()
    this.el.removeEventListener("click", this.handleClick)
  },
}
